import { createLocation } from '../../history';
export const resolveToLocation = (to, currentLocation) => {
  return typeof to === 'function' ? to(currentLocation) : to;
};
export const normalizeToLocation = (to, currentLocation) => {
  return typeof to === 'string' ?
  // @ts-ignore null for state/key — createLocation expects S | undefined but null is fine at runtime
  createLocation(to, null, null, currentLocation) : to;
};